/* eslint-disable react/jsx-props-no-spreading */
import { TextInput as MantineTextInput, TextInputProps, createStyles } from '@mantine/core';
import { getTypographyStyles } from '../../theme/themeConfig';

const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  return {
    input: {
      borderRadius: '4px',
      height: '44px',
      border: `1px solid ${colors.disabled.muted}`,
      backgroundColor: colors.bg.default,
      ...getTypographyStyles('content_sm_regular'),
      '&[data-with-icon]': {
        paddingLeft: '48px',
      },
    },
    icon: {
      marginLeft: '6px',
      color: colors.fg.default,
    },
  };
});

const TextInput = (props:TextInputProps) => {
  const { classes } = useStyles();
  return (
    <MantineTextInput
      classNames={{
        input: classes.input,
        icon: classes.icon,
      }}
      {...props}
    />
  );
};

export default TextInput;
